import '../common'

// Ne lehessen a jobb egérgombot használni.
import '../contextMenuPreventer/contextMenuPreventer'

// Ne engedjünk szöveget kijelölni.
import '../userSelectPreventer/userSelectPreventer'

// A lelke az egésznek: 16:9-es képarányt tartjuk és növeljük-csökkentjük a contentet,
// így nem kell responsive design és mindenen IS tud menni.
import ContentScale from '../ContentScale/ContentScale'

// A @common/common-ban vannak az általános css beállítások, de van pár extra, ami a játékokhoz kell.
import './game.css'

import touch from '../touch/touch'

ContentScale.init()

// Telefonon és tableten a duplakattos és a kétujjas zoomot gátoljuk ezzel.
touch.preventMultiTouch('body')

// F4 lenyomására a html-re debug class-t rak, amit lehet figyelni css-ben és extra infókat mutatni.
// Ez most production-ben is bent marad.
document.addEventListener('keydown', (e: KeyboardEvent) => {
  if (e.key === 'F4') {
    document.querySelector('html')?.classList.toggle('debug')
  }
  else if (e.key === 'F1') {
    document.querySelector('html')?.classList.toggle('grid')
  }
})
